export default "__VITE_IMAGE_ASSET__8f1e42da__";